<template>
  <div>
    <span class="icons">
      <span><b-icon-fonts></b-icon-fonts></span>
      <span><b-icon-fonts></b-icon-fonts></span>
    </span>

    <small>{{ fontSize }}%</small>
    
    <div class="buttons">
      <span @click.stop.prevent="decrement">
        <b-icon-caret-down-fill></b-icon-caret-down-fill>
      </span>
      <span @click.stop.prevent="increment">
        <b-icon-caret-up-fill></b-icon-caret-up-fill>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['fontSize'],

    methods: {
      decrement() {
        this.$emit('update:fontSize', Math.max(this.fontSize - 10, 50))
      },
      
      increment() {
        this.$emit('update:fontSize', Math.min(this.fontSize + 10, 300))
      }
    }
  }
</script>

<style scoped>
  .icons {
    margin-right: 0.35em;
  }

  .icons > :last-child {
    font-size: 0.75rem;
    margin-left: -5px;
    padding-bottom: 4px;
  }

  small {
    color: #aaa;
  }

  .buttons {
    float: right;
  }
</style>